var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebAssetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 0.666748H1.33333C0.593333 0.666748 0 1.26675 0 2.00008V10.0001C0 10.7334 0.593333 11.3334 1.33333 11.3334H10.6667C11.4 11.3334 12 10.7334 12 10.0001V2.00008C12 1.26675 11.4067 0.666748 10.6667 0.666748ZM10.6667 10.0001H1.33333V3.33341H10.6667V10.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebAssetIcon);
export default __webpack_public_path__ + "static/media/web-asset-icon.bceb0322e3d7aa44c5f1ee04036e1608.svg";
export { ForwardRef as ReactComponent };